
import Square3 from "../../../assets/filled/Square3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Square3Icon({ className, dataTestid = "Square3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Square3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
